import { Box, Card, CardBody, Heading, ResponsiveContext } from "grommet"
import { BoxWindow } from "../components/BoxWindow"
import { useNavigate, useParams } from "react-router-dom";
import { User } from "grommet-icons";
import { useGetDonateVariantsByUsernameQuery, useGetDonateVariantsQuery } from "../api/donateVariantsApi";
import { DonateVariantCardPreview } from "../components/donate-variants/DonateVariantCardPreview";
import { ResponsiveGrid } from "../components/ResponsiveGrid";
import { useCallback, useContext, useState } from "react";
import { AuctionDonateVariantDialog } from "../components/donate-variants/dialog/AuctionDonateVariantDialog";
import { RouletteDonateVariantDialog } from "../components/donate-variants/dialog/RouletteDonateVariantDialog";
import { PaymentOptionsSelector } from "../components/donate-variants/dialog/PaymentOptionsSelector";

const columns = {
    xsmall: ["auto"],
    small: ["auto"],
    medium: ["auto", "auto"],
    large: ["auto", "auto", "auto"],
    xlarge: ["auto", "auto", "auto"]
};

// if size if xsmall, we have 2 rows
// if size if small, we have 2 rows
// if size if medium, we have 2 rows
// if size if large or xlarge, we have 1 row
const rows = {
    xsmall: ["flex", "flex"],
    small: ["flex", "flex"],
    medium: ["flex"],
    large: ["flex"],
    xlarge: ["flex"]
};

const gap = {
    xsmall: 'medium',
    small: 'medium',
    medium: 'medium',
    large: 'medium',
    xlarge: 'medium'
}

export const DonatePage = () => {

    const params = useParams();
    const navigate = useNavigate();
    const size = useContext(ResponsiveContext);

    const { data: donateVariants, isLoading: isDonateVariantsLoading, isSuccess: isDonateVariantsLoaded } = useGetDonateVariantsByUsernameQuery({ username: params.username });

    const [dialogData, setDialogData] = useState({ data: undefined, show: false });
    const [sendData, setSendData] = useState();

    const handleWish = (data) => {
        if (data.type === 'MEMES') {
            navigate(`/memes/${params.username}`)
        } else {
            setDialogData({ data: data, show: true })
        }
    }

    const handleSubmit = useCallback((data) => {
        window.location.replace(data.paymentOption)
    }, [])

    return (
        <Box>
            <BoxWindow>
                <Card background="#222222" fill margin={{ top: 'medium' }}>
                    <CardBody pad="medium">
                        <Box direction="row" gap="small" align="center">
                            {/* <Avatar size="medium" src="https://static-cdn.jtvnw.net/jtv_user_pictures/adc955ce-4fb5-4255-8943-7d5cce4c9f03-profile_image-300x300.png"/> */}
                            <User size="large"/>
                            <Heading level={2} weight={'bolder'} >{params.username}</Heading>
                        </Box>
                    </CardBody>
                </Card>
            </BoxWindow>
            <BoxWindow>
                {isDonateVariantsLoaded && (
                    <Box>
                        <ResponsiveGrid
                            overrideRows={rows}
                            overrideColumns={columns}
                            // areas={areas}
                            gap={gap[size]}
                            justifyContent="start"
                            margin="none"
                        >
                            {donateVariants.map(row => (
                                <DonateVariantCardPreview data={row} onWish={handleWish} />
                            ))}
                        </ResponsiveGrid>
                    </Box>
                )}
                {dialogData.data?.type === 'AUCTION' && <AuctionDonateVariantDialog data={dialogData} onSubmit={handleSubmit} onClose={() => setDialogData(prev => ({ ...prev, ...{ show: false } }))} />}
                {dialogData.data?.type === 'ROULETTE' && <RouletteDonateVariantDialog data={dialogData} onSubmit={handleSubmit} onClose={() => setDialogData(prev => ({ ...prev, ...{ show: false } }))} />}
            </BoxWindow>
        </Box>
    )
}